import { render, staticRenderFns } from "./DeleteCustomerModal.vue?vue&type=template&id=602cbd8c"
import script from "./DeleteCustomerModal.vue?vue&type=script&lang=js"
export * from "./DeleteCustomerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports